import { useState } from 'react'
import { useQuery, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux'
import { useSnackbar } from "notistack";

import { PROJECTS, get, post, deleteElem, getErrorMessage } from "service/Client";
import { settings as SETTINGS } from "../constants";


const useSettings = () => {
	let project = useSelector(store => store.session.project)
	const [settings, setSettings] = useState([])

	const queryClient = useQueryClient()
	const { enqueueSnackbar } = useSnackbar();

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), { variant: "error" });
	}

	// getSettings
	useQuery(['settings', { pid: project?.id }],
		() => get(`${PROJECTS}/${project?.id}/settings`),
		{ enabled: !!project, onSuccess: setSettings, onError: showError }
	)

	function saveSettings() {
		return post(`${PROJECTS}/${project.id}/settings`, { body: settings })
			.then(() => queryClient.invalidateQueries(['settings', { pid: project.id }])).catch(showError)
	}

	function resetSettings() {
		queryClient.invalidateQueries(['settings', { pid: project.id }])
	}

	function deleteSetting(settingsId) {
		return deleteElem(`${PROJECTS}/${project.id}/settings/${settingsId}`)
			.then(resp => setSettings(resp.data)).catch(showError)
	}

	function getSettingValue(settingName, type, project, device) {
		const filteredSettings = settings.filter(s => s.name === settingName)
		let setting
		if (!!project && !!device) {
			setting = filteredSettings.find(s => s.typeId === type && s.projectId === project && s.deviceId === device)
		}
		if (!!project && !setting) {
			setting = filteredSettings.find(s => s.typeId === type && s.projectId === project && s.deviceId === undefined)
		}
		if (!setting) {
			setting = filteredSettings.find(s => s.typeId === type && s.projectId === undefined && s.deviceId === undefined)
		}
		return setting
	}

	function changeSetting(name, value, type, project, device) {
		let scope = device ? SETTINGS.scopes.DEVICE : project ? SETTINGS.scopes.PROJECT : type ? SETTINGS.scopes.TYPE : SETTINGS.scopes.SYSTEM
		let index = settings.findIndex(s => s.name === name && s.typeId === type && s.projectId === project && s.deviceId === device);
		let newSettings = settings.slice();
		if (index > -1) {
			newSettings[index].value = value.toString();
			newSettings[index].scope = scope
			if (type)
				newSettings[index].typeId = type
			if (project)
				newSettings[index].projectId = project
			if (device)
				newSettings[index].deviceId = device
		} else {
			newSettings.push({
				name,
				value: value.toString(),
				deviceId: device,
				projectId: project,
				typeId: type,
				scope: scope
			});
		}
		setSettings(newSettings);
	}

	function changeMultipleSettings(settingsToChange = []) { // elements {name, value, type, project}
		let newSettings = settings.slice();
		settingsToChange.forEach(c => {
			let scope = c.device ? SETTINGS.scopes.DEVICE : c.project ? SETTINGS.scopes.PROJECT : c.type ? SETTINGS.scopes.TYPE : SETTINGS.scopes.SYSTEM
			let index = newSettings.findIndex(s => s.name === c.name && s.typeId === c.type && s.projectId === c.project && s.deviceId === c.device);
			if (index > -1) {
				newSettings[index].value = c.value.toString();
				newSettings[index].scope = scope
				if (c.type)
					newSettings[index].typeId = c.type
				if (c.project)
					newSettings[index].projectId = c.project
			} else {
				newSettings.push({
					name: c.name,
					value: c.value.toString(),
					deviceId: c.device,
					projectId: c.project,
					typeId: c.type,
					scope: scope
				});
			}
		})
		setSettings(newSettings);
	}

	return { settings, saveSettings, resetSettings, deleteSetting, getSettingValue, changeSetting, changeMultipleSettings }
}

export { useSettings }
